import { Box, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '../../../../components/Button/Button';
import CdDrawer from '../../../../components/Drawer/CdDrawer';
import Input from '../../../../components/Input/Input';
import Loading from '../../../../components/Loading';
import RolePermissionsComponent from '../components/RolePermissionsComponent';
import usePermissions from '../../hooks/usePermissions';
import useRolesSave from './hooks/useRolesSave';

function RoleDrawerSave({ handleCloseDrawer, drawerAction, selectedItem }: any) {
    const {
        data,
        roleName,
        scrollRef,
        addingRole,
        updatingRole,
        formValidation,
        roleDescription,
        loadingRoleData,
        clearData,
        setRoleName,
        scrollView,
        handleSubmit,
        handleChangeData,
        setRoleDescription,
        ...restProps
    } = useRolesSave({ selectedItem, handleCloseDrawer, drawerAction });

    const { clearPermissionForm, ...permissionProps } = usePermissions({
        handleChangeData,
        data,
        drawerAction,
        selectedItem,
        scrollView
    });

    return (
        <CdDrawer
            open={['new', 'edit'].includes(drawerAction)}
            onClose={() => {
                return;
            }}
            onCloseButton={() => {
                clearData();
                clearPermissionForm();
                handleCloseDrawer();
            }}
            title={selectedItem ? `Rol ${selectedItem?.row?.nombre}` : 'Nuevo rol'}
            icon={<ArrowBackIcon />}
            disabled={formValidation}
            goBackTxt="Cerrar"
            onSubmit={drawerAction === 'new' ? handleSubmit : undefined}
            loading={addingRole || updatingRole}
            styles={{ width: '780px' }}
        >
            <Box height="calc(100% - 19px)">
                <Grid container spacing={1} columnSpacing={2} p={1}>
                    {loadingRoleData ? (
                        <Grid item xs={12}>
                            <Loading size="small" />
                        </Grid>
                    ) : (
                        <>
                            <Grid item xs={12} sx={{ '& h3': { mb: 0 } }}>
                                <h3>Datos del Rol</h3>
                            </Grid>
                            <Grid item xs={12}>
                                <Input
                                    label="Nombre del rol"
                                    name="nombre"
                                    onChange={(e: any) => setRoleName(e.target.value)}
                                    value={roleName || ''}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Input
                                    label="Descripción"
                                    name="descripcion"
                                    onChange={(e: any) => setRoleDescription(e.target.value)}
                                    value={roleDescription || ''}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            {drawerAction === 'edit' && (
                                <Grid item xs={12} display="flex" justifyContent="flex-end" px={2}>
                                    <Button
                                        disabled={formValidation}
                                        loading={updatingRole}
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <RolePermissionsComponent
                                    data={data}
                                    drawerAction={drawerAction}
                                    selectedItem={selectedItem}
                                    {...restProps}
                                    {...permissionProps}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
            <div ref={scrollRef} />
        </CdDrawer>
    );
}

export default RoleDrawerSave;
